<script lang="ts">
export default {
  name: 'PageProgress',
};
</script>

<template>
  <div class="progress text-center">
    <v-progress-circular :size="70" color="primary" indeterminate></v-progress-circular>
  </div>
</template>

<style scoped>
.progress {
  display: grid;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-items: center;
  height: 50vh;
}
</style>
